import React from "react";
import Draggable from 'react-draggable';
import { setWidgetDisplay } from "../db/action";
import { WidgetDisplay } from "../db/state";



const Widget: React.FC<React.PropsWithChildren<WidgetDisplay>> = ({
  children,
  colour,
  fontFamily,
  fontSize = 16,
  fontWeight,
  className = "",
  x = 0,
  y = 0,
  id
}) => {
  const setDisplay = setWidgetDisplay.bind(null, id);
  const nodeRef = React.useRef(null); // 用于解决 React 严格模式下的警告
  const handleDragStop = (e: any, data: any) => {
    // 拖拽停止时，调用回调函数并传递新位置
    // onPositionChange && onPositionChange({ x: data.x, y: data.y });
    setDisplay({ x: data.x, y: data.y });
  };

  return (
    <Draggable
      nodeRef={nodeRef}
      defaultPosition={{ x, y }} // 初始位置
      onStop={handleDragStop} // 拖拽停止时的回调
      // bounds="parent" // 将拖动限制在父元素内。如果需要在整个 body 拖动，请移除或修改此项
      // position={{ x, y }} // 如果希望实现受控组件，可以使用这个 prop，但需要配合 onStop 更新状态
    >
      <div
        ref={nodeRef}
        className={`Widget ${fontWeight ? "weight-override" : ""} widget-draggable ${className}`}
        style={{
          color: colour,
          fontFamily,
          fontSize: `${fontSize}px`,
          fontWeight,
          cursor: 'move',
        }}
      >
        {children}
      </div>
    </Draggable>
  )
}

export default Widget;
